import { ActivityCanvasService } from "./services/activity-canvas.service";
import { fontSizes } from "./services/workbook-activity.service";

declare var fabric: any;

let zoomInImg;
let zoomOutImg;
let deleteImg;
let moveImg;
let resizeImg;

let textbox;
const textTopOffsets = [6, 8, 6, 8, 6, 10, 14];

export const FabricCustom = {
  init: init,

  renderZoomIn: renderZoomIn,
  renderZoomOut: renderZoomOut,
  renderDelete: renderDelete,
  renderMove: renderMove,
  renderResizeWidth: renderResizeWidth,

  setZoomInEl: (el) => (zoomInImg = el),
  setZoomOutEl: (el) => (zoomOutImg = el),
  setDeleteEl: (el) => (deleteImg = el),
  setMoveEl: (el) => (moveImg = el),
  setResizeEl: (el) => (resizeImg = el),
};

function init() {
  const zoomInIcon =
    "data:image/svg+xml;base64,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";
  const zoomOutIcon =
    "data:image/svg+xml;base64,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";
  const deleteIcon =
    "data:image/svg+xml,%3C%3Fxml version='1.0'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' version='1.1' width='512' height='512' x='0' y='0' viewBox='0 0 384 384' style='enable-background:new 0 0 512 512' xml:space='preserve' class=''%3E%3Ccircle r='192' cx='192' cy='192' fill='%23d8d8db' shape='circle' transform='matrix(0.75,0,0,0.75,48,48)'/%3E%3Cg transform='matrix(0.4,0,0,0.4,115.20000457763672,115.19999999999999)'%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Cg%3E%3Cpath d='M64,341.333C64,364.907,83.093,384,106.667,384h170.667C300.907,384,320,364.907,320,341.333v-256H64V341.333z' fill='%2359595c' data-original='%23000000'/%3E%3Cpolygon points='266.667,21.333 245.333,0 138.667,0 117.333,21.333 42.667,21.333 42.667,64 341.333,64 341.333,21.333 ' fill='%2359595c' data-original='%23000000'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A";
  const moveIcon =
    "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' version='1.1' width='512' height='512' x='0' y='0' viewBox='0 0 492.001 492.001' style='enable-background:new 0 0 512 512' xml:space='preserve' class=''%3E%3Ccircle r='246.0005' cx='246.0005' cy='246.0005' fill='%23d8d8db' shape='circle'/%3E%3Cg transform='matrix(0.5,0,0,0.5,123.00006516312715,122.99999523162842)'%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Cpath d='M487.97,237.06l-58.82-58.82c-5.224-5.228-14.376-5.228-19.592,0l-7.436,7.432c-5.4,5.4-5.4,14.064,0,19.46l21.872,21.74 H265.206V68.396l21.808,22.132c5.224,5.22,14.216,5.22,19.428,0l7.36-7.432c5.404-5.404,5.356-14.196-0.044-19.596L254.846,4.444 c-2.6-2.592-6.088-4.184-9.804-4.184h-0.404c-3.712,0-7.188,1.588-9.784,4.184l-57.688,57.772 c-2.612,2.608-4.052,6.124-4.052,9.836c0,3.704,1.44,7.208,4.052,9.816l7.432,7.444c5.224,5.22,14.612,5.228,19.828,0.004 l22.368-22.132v159.688H67.814l22.14-22.008c2.608-2.608,4.048-6.028,4.048-9.732s-1.44-7.16-4.052-9.76l-7.436-7.42 c-5.22-5.216-14.372-5.2-19.584,0.008L4.034,236.856c-2.672,2.672-4.1,6.244-4.032,9.92c-0.068,3.816,1.356,7.388,4.028,10.056 l57.68,57.692c5.224,5.22,14.38,5.22,19.596,0l7.44-7.44c2.604-2.6,4.044-6.084,4.044-9.788c0-3.716-1.44-7.232-4.044-9.836 l-22.14-22.172H226.79V425.32l-23.336-23.088c-5.212-5.22-14.488-5.22-19.7,0l-7.5,7.44c-2.604,2.6-4.072,6.084-4.072,9.792 c0,3.704,1.424,7.184,4.028,9.792l58.448,58.456c2.596,2.592,6.068,4.028,9.9,4.028c0.024-0.016,0.24,0,0.272,0 c3.712,0,7.192-1.432,9.792-4.028l58.828-58.832c2.6-2.604,4.044-6.088,4.044-9.792c0-3.712-1.44-7.192-4.044-9.796l-7.44-7.44 c-5.216-5.22-14.044-5.22-19.264,0l-21.54,21.868V265.284H425.59l-23.096,23.132c-2.612,2.608-4.048,6.112-4.048,9.82 s1.432,7.192,4.048,9.8l7.44,7.444c5.212,5.224,14.372,5.224,19.584,0l58.452-58.452c2.672-2.664,4.096-6.244,4.028-9.916 C492.07,243.296,490.642,239.728,487.97,237.06z' fill='%2359595c' data-original='%23000000' class=''/%3E%3C/g%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A";
  const resizeIcon =
    "data:image/svg+xml,%3C%3Fxml version='1.0'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' version='1.1' width='512' height='512' x='0' y='0' viewBox='0 0 512 512' style='enable-background:new 0 0 512 512' xml:space='preserve' class=''%3E%3Ccircle r='256' cx='256' cy='256' fill='%23d8d8db' shape='circle' transform='matrix(0.7,0,0,0.7,76.80000000000001,76.80000000000001)'/%3E%3Cg transform='matrix(-0.3,0,0,0.3,332.79999999999995,179.19999999999993)'%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Cpath d='M496,0H304c-8.832,0-16,7.168-16,16v32c0,8.832,7.168,16,16,16h98.752L64,402.752V304c0-8.832-7.168-16-16-16H16 c-8.832,0-16,7.168-16,16v192c0,8.832,7.168,16,16,16h192c8.832,0,16-7.168,16-16v-32c0-8.832-7.168-16-16-16h-98.752L448,109.248 V208c0,8.832,7.168,16,16,16h32c8.832,0,16-7.168,16-16V16C512,7.168,504.832,0,496,0z' fill='%2359595c' data-original='%23000000' class=''/%3E%3C/g%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A";

  const zoomInEl = document.createElement("img");
  const zoomOutEl = document.createElement("img");
  const deleteEl = document.createElement("img");
  const moveEl = document.createElement("img");
  const resizeEl = document.createElement("img");

  zoomInEl.src = zoomInIcon;
  zoomOutEl.src = zoomOutIcon;
  deleteEl.src = deleteIcon;
  moveEl.src = moveIcon;
  resizeEl.src = resizeIcon;

  FabricCustom.setZoomInEl(zoomInEl);
  FabricCustom.setZoomOutEl(zoomOutEl);
  FabricCustom.setDeleteEl(deleteEl);
  FabricCustom.setMoveEl(moveEl);
  FabricCustom.setResizeEl(resizeEl);

  fabric.Object.prototype.lockScalingFlip = true;

  fabric.Object.prototype.controls.mt.actionHandler = () => {};
  fabric.Object.prototype.controls.mt.mouseUpHandler = decreaseFontSizeFn;
  fabric.Object.prototype.controls.mt.actionName = 'zoom-out';
  fabric.Object.prototype.controls.mt.render = renderZoomOut;
  fabric.Object.prototype.controls.mt.cursorStyleHandler = (
    eventData,
    corner,
    fabricObject
  ) => {
    return "default";
  };
  fabric.Object.prototype.controls.mt.getActionName = () => 'zoom-out';

  fabric.Object.prototype.controls.tl.render = renderMove;
  fabric.Object.prototype.controls.tl.cursorStyleHandler = (
    eventData,
    corner,
    fabricObject
  ) => {
    return "default";
  };
  fabric.Object.prototype.controls.tl.actionHandler = fabric.controlsUtils.dragHandler;
  fabric.Object.prototype.controls.tl.actionName = 'move';

  fabric.Object.prototype.controls.bl.actionHandler = () => {};
  fabric.Object.prototype.controls.bl.mouseUpHandler = increaseFontSizeFn;
  fabric.Object.prototype.controls.bl.actionName = 'zoom-in';
  fabric.Object.prototype.controls.bl.render = renderZoomIn;
  fabric.Object.prototype.controls.bl.cursorStyleHandler = (
    eventData,
    corner,
    fabricObject
  ) => {
    return "default";
  };
}
fabric.Object.prototype.controls.br.actionName = 'resize';
fabric.Object.prototype.controls.br.render = FabricCustom.renderResizeWidth;
fabric.Object.prototype.controls.br.cursorStyleHandler = (eventData, corner, fabricObject) => {
  return 'default';
};

fabric.Object.prototype.controls.tr.actionHandler = () => {};
fabric.Object.prototype.controls.tr.getActionName = () => 'remove';
fabric.Object.prototype.controls.tr.render = FabricCustom.renderDelete;
fabric.Object.prototype.controls.tr.cursorStyleHandler = (
  eventData,
  corner,
  fabricObject
) => {
  return "default";
};

fabric.Object.prototype.controls.bl.offsetY = 12;
fabric.Object.prototype.controls.bl.offsetX = 14;
fabric.Object.prototype.controls.mt.offsetY =
  fabric.Object.prototype.controls.bl.offsetY;
fabric.Object.prototype.controls.mt.offsetX =
  fabric.Object.prototype.controls.bl.offsetX + 24;
fabric.Object.prototype.controls.mt.y =
  fabric.Object.prototype.controls.bl.y;
fabric.Object.prototype.controls.mt.x =
  fabric.Object.prototype.controls.bl.x;

function decreaseFontSizeFn(eventData) {
  const object = ActivityCanvasService.activeCanvas.getActiveObject();

  if (object?.cType === "text") {
    let index = fontSizes.indexOf(ActivityCanvasService.fontSize);
    if (index > 0 && index <= fontSizes.length - 1) {
      index--;

      object.fontSize = fontSizes[index];
      ActivityCanvasService.fontSize = fontSizes[index];
      if (!object.cTopValues[index]) {
        if (index === 3) {
          object.top += 16;
        } else {
          object.top += textTopOffsets[index];
        }
        object.cTopValues = object.top;
      } else {
        object.top = object.cTopValues;
      }
      object.width =
        object.width / (fontSizes[index + 1] / fontSizes[index]);

      ActivityCanvasService.activeCanvas?.renderAll();
        if (object.cMinTextLines?.length) {
          object.cMinHeight = (object.__lineHeights[0]) * object.cMinTextLines.length;
        }
        object.cMinWidth = (Math.max(...object.__lineWidths)) + (ActivityCanvasService.fontSize / 3);
    } else {
      index = 0;
    }
  }

  if (object?.cType === "stamp") {
    const prevHeight = object.height * object.scaleY;
    let scale = object.scaleX * 0.75;
    ActivityCanvasService.stampSize = object.width * scale;
    if (ActivityCanvasService.stampSize < 25) {
      ActivityCanvasService.stampSize = 25;
      scale = ActivityCanvasService.stampSize / object.width;
    }
    object.scale(scale);
    const newHeight = object.height * object.scaleY;
    object.top += (prevHeight - newHeight); 
    ActivityCanvasService.activeCanvas?.renderAll();
  }
}

function increaseFontSizeFn(event) {
  const object = ActivityCanvasService.activeCanvas.getActiveObject();

  if (object?.cType === "text") {
    let index = fontSizes.indexOf(ActivityCanvasService.fontSize);
    if (index >= 0 && index < fontSizes.length - 1) {
      index++;

      object.fontSize = fontSizes[index];
      ActivityCanvasService.fontSize = fontSizes[index];

      if (!object.cTopValues[index]) {
        object.top -= textTopOffsets[index];
        object.cTopValues = object.top;
      } else {
        object.top = object.cTopValues;
      }
      object.width =
        object.width / (fontSizes[index - 1] / fontSizes[index]);
      ActivityCanvasService.activeCanvas?.renderAll();
        if (object.cMinTextLines?.length) {
          object.cMinHeight = (object.__lineHeights[0]) * object.cMinTextLines.length;
        }
        object.cMinWidth = (Math.max(...object.__lineWidths)) + (ActivityCanvasService.fontSize / 3);
    } else {
      index = fontSizes.length - 1;
    }
    return;
  }
  if (object?.cType === "stamp") {
    const prevHeight = object.height * object.scaleY;
    const newTop = object.top - ((prevHeight * 1.25) - prevHeight);
    if (newTop < 0) {
      return;
    }
    let scale = object.scaleX * 1.25;
    ActivityCanvasService.stampSize = object.width * scale;
    if (ActivityCanvasService.stampSize > 100) {
      ActivityCanvasService.stampSize = 100; 
      scale = ActivityCanvasService.stampSize / object.width;
    }
    object.scale(scale);
    const newHeight = object.height * object.scaleY;
    object.top -= (newHeight - prevHeight); 
    ActivityCanvasService.activeCanvas?.renderAll();
  }
}

function renderZoomIn(ctx, left, top, styleOverride, fabricObject) {
  renderIcon(ctx, left, top, styleOverride, fabricObject, "zoomIn");
}

function renderZoomOut(ctx, left, top, styleOverride, fabricObject) {
  renderIcon(ctx, left, top, styleOverride, fabricObject, "zoomOut");
}

function renderDelete(ctx, left, top, styleOverride, fabricObject) {
  renderIcon(ctx, left, top, styleOverride, fabricObject, "delete");
}

function renderMove(ctx, left, top, styleOverride, fabricObject) {
  renderIcon(ctx, left, top, styleOverride, fabricObject, "move");
}

function renderResizeWidth(ctx, left, top, styleOverride, fabricObject) {
  renderIcon(ctx, left, top, styleOverride, fabricObject, "resize");
}

function renderIcon(
  ctx,
  left,
  top,
  styleOverride,
  fabricObject,
  iconType: "zoomIn" | "zoomOut" | "delete" | "resize" | "move"
) {
  let size = 32;
  let image;
  switch (iconType) {
    case "zoomIn":
      size = 24;
      image = zoomInImg;
      break;
    case "zoomOut":
      size = 24;
      image = zoomOutImg;
      break;
    case "delete":
      image = deleteImg;
      break;
    case "move":
      size = 24;
      image = moveImg;
      break;
    case "resize":
      image = resizeImg;
      break;
  }
  ctx.save();
  ctx.translate(left, top);
  ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
  ctx.drawImage(image, -size / 2, -size / 2, size, size);
  ctx.restore();
}
